import React from "react";
import { Link } from "react-router-dom";
import {
  BASE_URL_COMPETITION,
  BASE_URL_MEDIA,
  BASE_URL_METABUDDY,
  CORPORATE_LOGO,
  IS_CORPORATE,
} from "../api/Constants";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import { getImageUrl } from 'components/helpers/Helpers';

const Footer = () => {
  const croporaeLogo = localStorage.getItem("corporateLogo") || CORPORATE_LOGO;
  const logo = IS_CORPORATE
    ? getImageUrl(croporaeLogo, BASE_URL_MEDIA)
    : `${BASE_URL_MEDIA}/apis/storage/competition-dashboard/static/media/logo.png`;
  return (
    <div className="main-footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-3 mb-3">
            <div className="border-right">
              <div className="logo">
                <a
                  href={
                    IS_CORPORATE ? BASE_URL_COMPETITION : BASE_URL_METABUDDY
                  }
                >
                  {" "}
                  <img src={logo} alt="" />{" "}
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-3">
            <div className="border-right center ">
              <div className="mb-2">
                <Link to="/">Fitness Challenges</Link>
              </div>

              <div className="mb-2">
                <Link to="/contact">Contact</Link>
              </div>
              <div className="mb-2">
                <Link to="/help-center">Help Center</Link>
              </div>
              <div className="mb-0">
                <span>
                  {" "}
                  <a
                    target="_blank"
                    href="https://voro-fit.com/terms-conditions/" rel="noreferrer"
                  >
                    {" "}
                    Terms{" "}
                  </a>{" "}
                </span>
                /
                <span>
                  {" "}
                  <a
                    target="_blank"
                    href="https://voro-fit.com/privacy-policy/" rel="noreferrer"
                  >
                    {" "}
                    Privacy
                  </a>{" "}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-3">
            <div className="border-right center ">
              <div className="social-footer">
                <a
                  className="iconn"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/voro.fit/"
                >
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a
                  className="iconn"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/company/metabuddy/"
                >
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a
                  className="iconn"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/@metabuddy"
                >
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-3">
            <div className=" center fotter-layout">
              <a href="https://play.google.com/store/apps/details?id=app.voro">
                <div className="d-flex flex-row download-button mb-3 b1">
                  <FaGooglePlay size={12} />
                  <span className="download-text">
                    <p className="download-text-1">Download From</p>
                    <p className="download-text-2">Google Play</p>
                  </span>
                </div>
              </a>
              <a href="https://apps.apple.com/us/app/vorofit/id6754451377">
                <div className="d-flex flex-row download-button">
                  <FaApple size={15} />
                  <span className="download-text">
                    <p className="download-text-1">Download From</p>
                    <p className="download-text-2">App Store</p>
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
